import { useState } from "react";

import {
  Button,
  DataList,
  EmptyState,
  ErrorState,
  Field,
  Input,
  Page,
  Panel,
  Skeleton,
  Stack,
  StatusBadge,
  Toolbar,
} from "@/components/ui";

import { useClaimNamespace, useMyNamespace } from "../lib/queries";

/** Claimed once, permanently. There is no second call that changes it. */
export function Namespace() {
  const [wanted, setWanted] = useState("");
  const held = useMyNamespace();
  const claim = useClaimNamespace();

  if (held.isPending) {
    return (
      <Page title="Namespace" eyebrow="Publisher">
        <Skeleton height={160} />
      </Page>
    );
  }

  if (held.isError) {
    return (
      <Page title="Namespace" eyebrow="Publisher">
        <ErrorState
          headline="Namespace unavailable"
          onRetry={() => void held.refetch()}
          retryLabel="Retry"
        />
      </Page>
    );
  }

  const namespace = held.data;

  return (
    <Page title="Namespace" eyebrow="Publisher">
      <Panel
        title="Namespace"
        action={
          <StatusBadge tone={namespace === null ? "neutral" : "success"}>
            {namespace === null ? "none" : "held"}
          </StatusBadge>
        }
      >
        {namespace === null ? (
          <Stack gap={5}>
            <EmptyState bare headline="No namespace claimed" />
            <Toolbar fill>
              <Field label="Namespace">
                <Input
                  mono
                  value={wanted}
                  onChange={(event) => {
                    setWanted(event.target.value);
                  }}
                />
              </Field>
              <Button
                variant="primary"
                disabled={wanted.trim() === ""}
                loading={claim.isPending}
                onClick={() => {
                  claim.mutate(wanted.trim());
                }}
              >
                Claim
              </Button>
            </Toolbar>
            {claim.isError ? <ErrorState headline={claim.error.message} /> : null}
          </Stack>
        ) : (
          <DataList
            items={[
              {
                id: namespace.namespace,
                title: namespace.namespace,
                fields: [
                  { label: "Claimed", value: namespace.claimed_at },
                  { label: "Account", value: namespace.account_id, mono: true },
                ],
              },
            ]}
          />
        )}
      </Panel>
    </Page>
  );
}
